import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { RefreshCw, Sparkles } from "lucide-react";
import { HelioCheckoutWidget } from "./HelioCheckoutWidget";

interface UpgradeModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onRefreshStatus: () => void;
  isRefreshing?: boolean;
}

export function UpgradeModal({ 
  open, 
  onOpenChange, 
  onRefreshStatus,
  isRefreshing = false 
}: UpgradeModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-primary" />
            Upgrade to Pro
          </DialogTitle>
          <DialogDescription>
            Unlock unlimited exports, advanced analytics, and priority support.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-4">
          <HelioCheckoutWidget />
        </div>

        <div className="mt-4 pt-4 border-t border-border">
          <p className="text-sm text-muted-foreground mb-3">
            After payment, click below to refresh your subscription status:
          </p>
          <Button 
            variant="outline" 
            className="w-full"
            onClick={onRefreshStatus}
            disabled={isRefreshing}
          >
            <RefreshCw className={`w-4 h-4 mr-2 ${isRefreshing ? "animate-spin" : ""}`} />
            {isRefreshing ? "Checking..." : "Refresh Status"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
